import { io } from 'socket.io-client';

const URL = process.env.REACT_APP_API_URL;
let socket = null;

export const initializeSocket = (token) => {
    socket = io(URL, {
        query: { token }
    });
    return socket;
};

export const closeSocket = () => {
    if (socket) {
        socket.close();
    }
};

export const getSocket = () => socket;
